import { useEffect } from 'react';
import type { ShellPersona } from '../app-shell/moduleRegistry';
import type { CognitoProfile } from '../utils/cognito-profile';
import { clearLogRocketIdentity, identifyLogRocketUser } from './logrocket';

type UseLogRocketIdentityInput = {
  profile: CognitoProfile | null;
  effectivePersona: ShellPersona;
  basePersona: ShellPersona;
  authStatus: string;
};

const groupsKey = (profile: CognitoProfile | null): string =>
  Array.isArray(profile?.groups) ? profile.groups.filter(Boolean).join('|') : '';

export const useLogRocketIdentity = (input: UseLogRocketIdentityInput) => {
  useEffect(() => {
    if (input.authStatus !== 'authenticated') {
      clearLogRocketIdentity();
      return;
    }

    identifyLogRocketUser({
      profile: input.profile,
      effectivePersona: input.effectivePersona,
      basePersona: input.basePersona,
      authStatus: input.authStatus,
    });
  }, [
    input.authStatus,
    input.effectivePersona,
    input.basePersona,
    input.profile?.email,
    input.profile?.name,
    input.profile?.userSub,
    input.profile?.provider,
    input.profile?.isGoogleProvider,
    input.profile?.isIntellioUser,
    input.profile?.isSuperAdmin,
    groupsKey(input.profile),
  ]);
};
